import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IndexedDBInterface } from './interface/indexedDB.interface';
import { environment } from 'src/environments/environment';
import { objectStoreName } from './common/objectStoreName';

@Injectable({
  providedIn: 'root',
})
export class AreaIndexedDBService implements IndexedDBInterface {
  objectStoreName = objectStoreName.areaStoreName;
  dbName = environment.indexDBName;

  constructor() {}

  storeDataInIndexedDB(Areas: { id: number; name: string }[]): void {
    const dbRequest = indexedDB.open(this.dbName);
    dbRequest.onsuccess = (event: any) => {
      const db = event.target.result;
      const transaction = db.transaction(this.objectStoreName, 'readwrite');
      const objectStore = transaction.objectStore(this.objectStoreName);

      Areas.forEach((area) => {
        objectStore.put(area);
      });

      transaction.oncomplete = () => {
        // console.log('areas stored successfully');
      };

      transaction.onerror = (event) => {
        // console.error('Error storing areas:', event.target.error);
      };
    };
  }

  getStoredData(): Observable<{ id: number; name: string }[]> {
    const dbRequest = indexedDB.open(this.dbName);

    return new Observable((observer) => {
      dbRequest.onsuccess = (event: any) => {
        const db = event.target.result;
        const transaction = db.transaction(this.objectStoreName, 'readonly');
        const objectStore = transaction.objectStore(this.objectStoreName);
        const request = objectStore.getAll();

        request.onsuccess = (event) => {
          const areas = (event.target.result as { id: number; name: string }[])
            .sort((areaA, areaB) => areaA.name.localeCompare(areaB.name));
          observer.next(areas);
          observer.complete();
        };

        request.onerror = (event) => {
          console.error('Error retrieving areas:', event.target.error);
          observer.error(event.target.error);
        };
      };

      dbRequest.onerror = (event: any) => {
        console.error('Error opening database:', event.target.error);
        observer.error(event.target.error);
      };
    });
  }
}
